<template>
	<div>
		<case-form :schema="schema" />
	</div>
</template>

<script>
import CaseForm from "../../CaseForm/CaseForm.vue"

export default {
	name: "PJProposalTerritoriesCovered",
	components: { CaseForm },
	data() {
		return {
			schema: [
				{
					label: "C. Territories Covered",
					component: "select",
					bindTo: "case.facts.territoriesCovered",
					props: {
						options: [
							{
								name:
									"Domestic Cover: Hong Kong, Kowloon and New Territories or Thailand or South East Asia country",
								value:
									"Domestic Cover: Hong Kong, Kowloon and New Territories or Thailand or South East Asia country"
							},
							{
								name: "Global Cover",
								value: "Global Cover"
							}
						]
					}
				}
			]
		}
	}
}
</script>
